module.exports = __webpack_public_path__ + "img/bg_welcome.9f6d512a.png";